import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, LayoutGrid, ShoppingCart, User } from 'lucide-react';
import { useCart } from '@/contexts/CartContext';
import { useAuth } from '@/contexts/AuthContext';

const navItems = [
    { to: '/', icon: Home, label: 'Home' },
    { to: '/shop', icon: ShoppingBag, label: 'Shop' },
    { to: '/shop?view=categories', icon: LayoutGrid, label: 'Categories' },
    { to: '/cart', icon: ShoppingCart, label: 'Cart', showBadge: true },
    { to: '/account', icon: User, label: 'Account' },
];

export default function MobileNav() {
    const location = useLocation();
    const { cartCount } = useCart();
    const { user } = useAuth();

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]" data-testid="mobile-bottom-nav">
            <div className="flex items-center justify-around h-16 px-2">
                {navItems.map(({ to, icon: Icon, label, showBadge }) => {
                    const actualTo = label === 'Account' ? (user ? (user.role === 'admin' ? '/admin' : '/account') : '/login') : to;
                    const isActive = label === 'Home' ? location.pathname === '/' : location.pathname.startsWith(to.split('?')[0]) && to !== '/';
                    return (
                        <Link key={label} to={actualTo}
                            className={`flex flex-col items-center justify-center gap-0.5 w-16 h-14 rounded-xl transition-all ${isActive ? 'text-pink-600' : 'text-gray-400 hover:text-gray-600'}`}
                            data-testid={`mobile-nav-${label.toLowerCase()}`}>
                            <div className="relative">
                                <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 1.5} />
                                {showBadge && cartCount > 0 && (
                                    <span className="absolute -top-1.5 -right-2 bg-pink-600 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">{cartCount}</span>
                                )}
                            </div>
                            <span className={`text-[10px] font-body ${isActive ? 'font-semibold' : 'font-medium'}`}>{label}</span>
                        </Link>
                    );
                })}
            </div>
            <div className="h-safe-area-inset-bottom bg-white" />
        </nav>
    );
}
